// extracted by mini-css-extract-plugin
export default {"component":"BookingWrap_component__b2WBQ"};